export default __webpack_public_path__ + "static/media/PLU-BEERCARD-A4-1-bckg-1.6d1696ec.jpg";